import Vue from 'vue';
import { RolloverOtpService } from '~/app/features/rollover-otp/services/rollover-otp.service';
import { LoadingService } from '~/app/features/social-fund/services/loading.service';

export default function services(ctx, inject) {
  const loadingService = new LoadingService(ctx);
  const rolloverOtpService = new RolloverOtpService(ctx);

  Vue.prototype.$rolloverOtpService = rolloverOtpService;

  inject('rolloverOtpService', rolloverOtpService);
  inject('loadingService', loadingService);
}
